module.exports = __webpack_public_path__ + "img/Pitcairn Islands.9533d32a.svg";